/* @flow */
import { RECEIVE_FOUNDRY_RESPONSE } from '../actions/foundry_response';
import { SET_ADS_TARGETED } from '../actions/ads';
import { CHANGE_SLIDE } from '../actions/slide';
import type { Action } from '../actions/types';

const initialState = {
  vendors: {},
  adTargetingCompleted: false,
  slideChangeCount: 0
};

export default (state: AdsState = initialState, action: Action): AdsState => {
  switch (action.type) {
    case RECEIVE_FOUNDRY_RESPONSE:
      return {
        ...state,
        ad_data: {
          ...state.ad_data,
          ...action.data.ad_data
        }
      };
    case SET_ADS_TARGETED:
      return {
        ...state,
        adTargetingCompleted: action.value
      };
    case CHANGE_SLIDE:
      return {
        ...state,
        slideChangeCount: state.slideChangeCount + 1
      };
    default:
      return state;
  }
};

type AdsState = {
  ad_data?: Object,
  adTargetingCompleted: bool,
  slideChangeCount: number,
  vendors: Object
};
